export default {
  type: 'my_review_new',
  name: 'ARM Staff Updates',
  save: {
    fields: [
      { field: 'personId', type: 'Int', required: true },
      'groupRecords',
      'activeEmailRecords'
    ],
    key: ['personId']
  },
  load: {
    key: 'personByPersonId'
  },
  form: {
    print: false,
    redirects: false,
    editHeader: 'ARM Staff Updates',
    schema: [
      {
        type: 'select',
        name: 'updateType',
        labelWidth: 2,
        options: ['New Staff', 'Update Role / Location', 'Departing Staff']
      },
      {
        type: 'message',
        message: 'If user cannot be found, enter user info below',
        showIf: {
          field: 'newPersonId',
          value: null
        }
      },
      {
        name: 'newPersonId',
        type: 'link',
        label: 'User',
        search: {
          field: 'personId',
          lookup: 'allPeople',
          filters: {
            statusCode: {
              in: {
                type: 'StringArray',
                array: true,
                required: true,
                default: '["A", "M", "F"]'
              }
            }
          },
          fieldWidth: 3,
          additionalFields: [
            {
              name: 'fullName',
              label: 'Name',
              width: 4,
              copyTo: 'name'
            },
            {
              name: 'email',
              width: 5,
              copyTo: 'email'
            },
            {
              name: 'username',
              width: 3,
              copyTo: 'username'
            },
            {
              name: 'affiliation',
              width: 9,
              copyTo: 'affiliation'
            }
          ]
        }
      },
      {
        type: 'group',
        showIf: {
          field: 'newPersonId',
          value: null
        },
        fields: [
          {
            name: 'username',
            type: 'hidden'
          },
          [
            {
              name: 'name',
              labelWidth: 3,
              width: 6
            },
            {
              name: 'email',
              labelWidth: 3,
              width: 6
            }
          ],
          {
            name: 'affiliation',
            labelWidth: 2,
            type: 'link',
            search: {
              field: 'instName',
              lookup: 'allInstitutions',
              additionalFields: [
                {
                  name: 'address1',
                  type: 'hidden'
                },
                {
                  name: 'address2',
                  type: 'hidden'
                },
                {
                  name: 'city',
                  type: 'hidden'
                },
                {
                  name: 'state',
                  type: 'hidden'
                },
                {
                  name: 'zipCode',
                  type: 'hidden'
                },
                {
                  name: 'countryCode',
                  type: 'hidden'
                },
                {
                  name: 'smallBusiness',
                  type: 'hidden'
                }
              ]
            }
          }
        ]
      },
      {
        name: 'jobTitle',
        label: 'Job Title or Description',
        labelWidth: 3
      },
      [
        {
          name: 'departDate',
          label: 'Departure Date',
          type: 'date',
          width: 6,
          labelWidth: 6,
          showIf: {
            field: 'updateType',
            value: 'Departing Staff'
          }
        }
      ],
      [
        {
          name: 'deactivateAccount',
          label: 'Deactivate Account Immediately',
          type: 'checkbox',
          width: 6,
          labelWidth: 8,
          showIf: {
            field: 'updateType',
            value: 'Departing Staff'
          }
        }
      ],
      [
        {
          name: 'startDate',
          label: 'Start or Transition Date',
          type: 'date',
          width: 6,
          labelWidth: 6,
          hideIf: {
            field: 'updateType',
            value: 'Departing Staff'
          }
        },
        {
          name: 'servicenow',
          label: 'Will Staff Need a ServiceNow License?',
          type: 'select',
          labelWidth: 8,
          width: 6,
          options: ['Unknown', 'Yes', 'No'],
          hideIf: {
            field: 'updateType',
            value: 'Departing Staff'
          }
        }
      ],
      {
        type: 'group',
        headerButton: false,
        label: 'Staff Infrastructure Area',
        hideIf: {
          field: 'updateType',
          value: 'Departing Staff'
        },
        fields: [
          [
            {
              name: 'tdo',
              label: 'Technical Coordination',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            },
            {
              name: 'eng',
              label: 'Engineering',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            }
          ],
          [
            {
              name: 'ops',
              label: 'Operations',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            },
            {
              name: 'wdcomms',
              label: 'Web Development /  Communications',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            }
          ],
          [
            {
              name: 'it',
              label: 'Instrument Mentor',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            },
            {
              name: 'dc',
              label: 'Data Center / ARM Developers',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            }
          ],
          [
            {
              name: 'sds',
              label: 'SDS / ADC Admins',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            },
            {
              name: 'dqo',
              label: 'Data Quality Office',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            }
          ],
          [
            {
              name: 'vap',
              label: 'VAP Developers',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            },
            {
              name: 'so',
              label: 'Site Operations',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            }
          ],
          [
            {
              name: 'support',
              label: 'Misc. Support',
              type: 'checkbox',
              labelWidth: 8,
              width: 6
            }
          ],
          {
            name: 'other',
            labelWidth: 1
          },
          {
            type: 'group',
            label: 'Observatory / Operations Area',
            showIf: {
              field: 'so',
              value: true
            },
            fields: [
              [
                {
                  name: 'ena',
                  label: 'Eastern North Atlantic',
                  type: 'checkbox',
                  labelWidth: 8,
                  width: 4
                },
                {
                  name: 'nsa',
                  label: 'North Slope of Alaska',
                  type: 'checkbox',
                  labelWidth: 8,
                  width: 4
                },
                {
                  name: 'sgp',
                  label: 'Southern Great Plains',
                  type: 'checkbox',
                  labelWidth: 8,
                  width: 4
                }
              ],
              [
                {
                  name: 'amf1',
                  label: 'ARM Mobile Facility 1',
                  type: 'checkbox',
                  labelWidth: 8,
                  width: 4
                },
                {
                  name: 'amf2',
                  label: 'ARM Mobile Facility 2',
                  type: 'checkbox',
                  labelWidth: 8,
                  width: 4
                },
                {
                  name: 'amf3',
                  label: 'ARM Mobile Facility 3',
                  type: 'checkbox',
                  labelWidth: 8,
                  width: 4
                }
              ],
              [
                {
                  name: 'aaf',
                  label: 'ARM Aerial Facility',
                  type: 'checkbox',
                  labelWidth: 8,
                  width: 4
                },
                {
                  name: 'tbs',
                  label: 'Tethered Balloon System (TBS)',
                  type: 'checkbox',
                  labelWidth: 8,
                  width: 4
                }
              ]
            ]
          }
        ]
      },
      {
        type: 'hr',
        hideIf: {
          field: 'updateType',
          value: 'Departing Staff'
        }
      },
      {
        type: 'message',
        message:
          'Please note that adding a user to a group with an associated email list(s) will also add the user to that email list(s)',
        hideIf: {
          field: 'updateType',
          value: 'Departing Staff'
        }
      },
      {
        name: 'groupRecords',
        label: 'My Groups To Add Them To',
        selectedMessage: 'Add to Group:',
        labelWidth: 12,
        type: 'results',
        hideIf: {
          field: 'updateType',
          value: 'Departing Staff'
        },
        fields: [
          {
            key: 'groupId',
            sortable: true,
            required: true
          },
          {
            key: 'groupName',
            label: 'Name',
            sortable: true,
            required: true
          },
          {
            key: 'groupDescription',
            label: 'Description',
            sortable: true
          },
          {
            key: 'associatedEmails'
          },
          {
            key: 'selected',
            label: 'Add To Group'
          }
        ]
      },
      {
        name: 'activeEmailRecords',
        label: 'My Email Lists To Add Them To',
        selectedMessage: 'Add to Email List:',
        labelWidth: 12,
        type: 'results',
        hideIf: {
          field: 'updateType',
          value: 'Departing Staff'
        },
        fields: [
          {
            key: 'emailList',
            sortable: true,
            required: true
          },
          {
            key: 'topicsList',
            label: 'Description',
            sortable: true
          },
          {
            key: 'selected',
            label: 'Add To Email List'
          }
        ]
      },
      {
        name: 'otherSubscribeTo',
        label: 'Other Public/Infrastructure Email Lists to Subscribe Them To',
        type: 'graphql_form_search_multi',
        hideIf: {
          field: 'updateType',
          value: 'Departing Staff'
        },
        fields: [
          {
            key: 'emailList',
            sortable: true,
            required: true
          },
          {
            key: 'remove'
          }
        ],
        formType: 'emails',
        multiHeader: 'Added ${emailList} to subscriptions',
        addLabel: 'Add Subscription',
        searchFilters: {
          listLevel: {
            in: {
              type: 'StringArray',
              array: true,
              required: true,
              default: '["I", "P", "F", "C"]'
            }
          }
        }
      },
      {
        type: 'hr'
      },
      {
        name: 'otherInformation',
        label:
          'Please add any additional details that might assist with account updates for this individual, including associated ARM roles, location information, or associated application needs or changes',
        type: 'textarea'
      }
    ],
    submitLabel: 'Submit ARM Staff Update'
  }
}
